import {
  useGetReportListQuery,
  useGetReportsPaginationCountQuery,
} from "../../actions/report.action";
import Alert from "../../components/alert";
import Pagination from "../../components/pagination";
import useQueryParams from "../../hooks/useQueryParams";
import useScreenName from "../../hooks/useScreenName";
import { getPaginationCount } from "../../utils";
import GenerateReportForm from "./generateReportForm";
import ReportsTable from "./reportsTable";

type ReportScreenProps = {
  isPreProd?: boolean;
};

type SearchQueryType = {
  pageNo: number;
  numberOfEntitiesPerPage: number;
};

const DEFAULT_SEARCH_QUERY_STATE: SearchQueryType = {
  pageNo: 1,
  numberOfEntitiesPerPage: 10,
};

export default function ReportsScreen({
  isPreProd = false,
}: ReportScreenProps) {
  useScreenName("Reports");

  const [{ pageNo, numberOfEntitiesPerPage }, setSearchQuery] =
    useQueryParams<SearchQueryType>(DEFAULT_SEARCH_QUERY_STATE);

  const {
    data: reportList,
    error: reportListError,
    isLoading: isReportListLoading,
  } = useGetReportListQuery({
    pageNo,
    numberOfEntitiesPerPage,
    ...(isPreProd && { isPreProd }),
  });

  const { data: paginationCountData, error: paginationCountError } =
    useGetReportsPaginationCountQuery({ ...(isPreProd && { isPreProd }) });

  const reportPaginationCount = paginationCountData?.totalCount ?? 0;

  const errorMessage =
    (reportListError &&
      "data" in reportListError &&
      (reportListError as any).data?.message) ||
    (paginationCountError &&
      "data" in paginationCountError &&
      (paginationCountError as any).data?.message) ||
    null;

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Alert type="danger" message={errorMessage} />
        <GenerateReportForm isPreProd={isPreProd} />
        <ReportsTable
          reportList={reportList}
          isReportListLoading={isReportListLoading}
        />
      </div>

      <Pagination
        currentPage={pageNo}
        totalEntries={getPaginationCount(
          reportPaginationCount,
          numberOfEntitiesPerPage,
        )}
        numberOfEntriesPerPage={numberOfEntitiesPerPage}
        onPageChange={(pageNo) =>
          setSearchQuery((prevState) => ({
            ...prevState,
            pageNo,
          }))
        }
        onPerPageCountChange={(countPerPage) =>
          setSearchQuery((prevState) => ({
            ...prevState,
            numberOfEntitiesPerPage: countPerPage,
            pageNo: 1,
          }))
        }
      />
    </>
  );
}
